import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { CgMenuLeft } from 'react-icons/cg'
import { FiEdit } from 'react-icons/fi'
import classNames from 'classnames'
import { useAllergicByIdQuery, useDeleteAllergicsMutation } from '../../../../services/rtk-query'
import { useDispatch } from 'react-redux'
import { activarModalGenerico, setActiveAllergic } from '../../../../store/slices/uiSlice'
import { ACTIONS } from '../../../../constants'
import { alertConfirm, toastAdapter } from '../../../../plugins'

export const Options = ({ cell, setAction, activo, ...rest }) => {
  const [deleteAllergic] = useDeleteAllergicsMutation()
  const dispatch = useDispatch()
  const [skip, setSkip] = useState(true)

  const { data, isSuccess, isFetching } = useAllergicByIdQuery(cell, {
    skip,
    refetchOnMountOrArgChange: true
  })
  const onEvent = () => {
    setSkip(false)
  }

  const onDelete = () => {
    alertConfirm({
      title: 'Habilitar o Desabilitar registro',
      text: '¿Estas seguro de Habilitar o Desabilitar este registro?',
      icon: 'warning',
      confirmButtonText: 'Si, Habilitar o Desabilitar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result) {
        toastAdapter.promise({
          promise: deleteAllergic({ id: cell, activo }).unwrap(),
          success: 'Registro Habilitado o Inhabilitado con éxito',
          error: 'Error al habilitar o deshabilitar el registro'
        })
      }
    })
  }

  // Actualizar el estado con los datos de la consulta cuando la consulta tenga éxito
  useEffect(() => {
    if (isSuccess) {
      setTimeout(() => {
        setAction(ACTIONS.UPDATE)
        dispatch(setActiveAllergic(data))
        dispatch(activarModalGenerico())

        setSkip(true)
      }, 300)
    }
  }, [isSuccess, data, dispatch, isFetching])
  return (
    <Dropdown flip drop="left">
      <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
        <CgMenuLeft />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={onEvent} disabled={rest.hasPermission}>
          <FiEdit /> Actualizar
        </Dropdown.Item>
        <Dropdown.Item
          className={classNames('text-danger', {
            opacity: rest.hasPermission
          })}
          onClick={onDelete}
          disabled={rest.hasPermission}
        >
          Habilitar/Inhabilitar
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}
